<template>
    <IndexBase @auth="onAuth($event)" action="Index" controller="BaFinal"></IndexBase>

    <Card>
        <template #title>
            <Toolbar>
                <template #left>
                    <div class="p-card-title">
                       BA ST Final
                    </div>
                </template>
                <template #right>
                    <Button :label="'Excel'"  icon="pi pi-file-excel"  class="p-button-success p-button-sm" @click="downloadPrint('EXCEL')" />
                </template>
            </Toolbar>
        </template>
        <template #content>
            <DataTable ref="dt" responsiveLayout="scroll" class="p-datatable-sm" filterDisplay="row" sortMode="multiple" removableSort
                stateStorage="local"
                :stateKey="stateKey"
                :value="dataModel" :loading="!dataModel || loading"
                :paginator="true"
                :rows="10"
                :lazy="true"
                v-model:first="this.start"
                @rowExpand="onRowExpand"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50, 100]" currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                @state-restore="onStateRestore($event)"
                @page="onPage($event)"
                @sort="onSort($event)"
                @filter="onFilter($event)"
                @update:selection="onSelect($event)"
                @row-dblclick="onRowDoubleClick"
                v-model:filters="filters"
                :totalRecords="totalRecords"
                dataKey="Id" :metaKeySelection="false" :rowClass="rowClass" id="main">
                
                <Column :exportable="false" :sortable="false" headerStyle="white-space:nowrap">
                    <template #header>
                    </template>
                    <template #filter>
                        <Button :label="$t('clear')" icon="pi pi-filter-slash"
                            class="p-button-outlined p-button-primary p-button-sm" @click="clearFilter" :badge="filterBadge"
                            badgeClass="p-badge-danger" />
                    </template>
                    <template #body="dataModel">

                            <Button icon="pi pi-search" v-show="canView" class="p-button-rounded p-button-info mr-2 p-button-sm"
                                @click="editor(this.$FORM_MODE_VIEW, dataModel.data.Main_Data_Id,dataModel.data.Id)" />
                            <Button icon="pi pi-pencil" v-show="canEdit && dataModel.data.Is_Deleted == 'N' && ( dataModel.data.Status != this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL && dataModel.data.Status != this.$APPROVAL_STATUS.APPROVED && dataModel.data.Status != this.$APPROVAL_STATUS.REJECTED)"
                                class="p-button-rounded p-button-success mr-2 p-button-sm"
                                @click="editor(this.$FORM_MODE_EDIT, dataModel.data.Main_Data_Id,dataModel.data.Id)" />
                            <Button icon="pi pi-trash" v-show="canDelete && dataModel.data.Is_Deleted == 'N' && ( dataModel.data.Status != this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL && dataModel.data.Status != this.$APPROVAL_STATUS.APPROVED && dataModel.data.Status != this.$APPROVAL_STATUS.REJECTED && dataModel.data.Status != this.$APPROVAL_STATUS.FULL_APPROVAL)"
                                class="p-button-rounded p-button-danger mr-2 p-button-sm"
                                @click="editor(this.$FORM_MODE_DELETE, dataModel.data.Main_Data_Id,dataModel.data.Id)" />
                        

                        <Button icon="pi pi-file-pdf p-button-icon" v-show="canPrint && dataModel.data.Is_Deleted == 'N'"
                            class="p-button p-component p-button-icon-only p-button-rounded p-button-danger p-button-outlined mr-2"
                            @click="generatePdf(dataModel.data.Id)"  target="_blank"/>
                    </template>
                </Column>
              
                <Column field="Status" :header="$t('status')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('status')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                    <template #body="{ data }">
                        <span v-if="data.Status == this.$APPROVAL_STATUS.CANCELLED" style="color: red;"> {{ data.Status }} </span>
                        <span v-else > {{ data.Status }} </span>
                    </template>
                </Column>
                <Column field="Status_Payment" :header="$t('Status_Payment')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('Status_Payment')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>   

                <Column field="No_WO" :header="$t('no_wo')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('no_wo')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                
                <Column field="Doc_No" :header="$t('doc_no')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('doc_no')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>

                <Column field="Rev" :header="$t('rev')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('rev')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                <Column field="No_SPO" :header="$t('no_spo')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('no_spo')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>   
                <Column field="job_desc" :header="$t('job_desc')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('job_desc')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>

                <Column field="location" :header="$t('location')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('location')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
                
                <Column field="project_manager" :header="$t('pic_pm')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('pic_pm')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>

                <Column field="project_coordinator" :header="$t('pic_cp')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('pic_cp')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>

                <Column field="contractor_pic" :header="$t('pic_contractor')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('pic_contractor')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
              
                <Column field="head_unit" :header="$t('head_unit')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" :placeholder="$t('head_unit')" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()"
                            class="p-column-filter p-inputtext-sm" />
                    </template>
                </Column>
              
                <Column field="Created_Date" :header="$t('created_date')" dataType="date" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <DatePicker :placeholder="$t('created_date')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999"
                            momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="filterModel"
                            v-model="filterModel.value" @keydown.enter="filterCallback()" @date-select="filterCallback()" />
                    </template>
                    <template #body="{ data }">
                        {{ this.$formatDateTime(data.Created_Date) }}
                    </template>
                </Column>
                <Column field="Created_By" :header="$t('created_by')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"
                            :placeholder="$t('created_by')" />
                    </template>
                </Column>
                <Column field="Edited_Date" :header="$t('edited_date')" dataType="date" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <DatePicker dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                            class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" 
                            :placeholder="$t('edited_date')"
                            @date-select="filterCallback()" />
                    </template>
                    <template #body="{ data }">
                        {{ this.$formatDateTime(data.Edited_Date) }}
                    </template>
                </Column>
                <Column field="Edited_By" :header="$t('edited_by')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"
                            :placeholder="$t('edited_by')" />
                    </template>
                </Column>
                <Column field="Is_Deleted" :header="$t('is_deleted')" dataType="date" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <YNSelect :placeholder="$t('is_deleted')" :useBinary="true" v-if="filterModel"
                            v-model="filterModel.value" @change="filterCallback()" />
                    </template>
                </Column>
                <Column field="Deleted_Date" :header="$t('deleted_date')" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <DatePicker dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                            class="p-column-filter p-inputtext-sm" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" @date-select="filterCallback()"
                            :placeholder="$t('deleted_date')" />
                    </template>
                    <template #body="{ data }">
                        {{ this.$formatDateTime(data.Deleted_Date) }}
                    </template>
                </Column>
                <Column field="Deleted_By" :header="$t('deleted_by')" dataType="date" :sortable="true">
                    <template #filter="{ filterModel, filterCallback }">
                        <InputText type="text" v-if="filterModel" v-model="filterModel.value"
                            @keydown.enter="filterCallback()" class="p-column-filter p-inputtext-sm"
                            :placeholder="$t('deleted_by')" />
                    </template>
                </Column>
            </DataTable>
        </template>
    </Card>
</template>

<script>
import IndexBase from '../Helper/IndexBase.vue'

export default {
    name: "BAFINAL",
    components: {
        'IndexBase': IndexBase
    },
    data() {
        return {
            dataModel: null,
            loading: true,
            totalRecords: 0,
            start: 0,
            stateKey: this.$STATE_NAME + 'bafinal-' + this.$store.getters.getUsername,
            isAdmin: this.$store.getters.getIsAdmin,
            sorts: null,
            lazyParams: {},
            filters: null,
            stateFilters: null,
            editorPath: "/BaFinal/Editor",
            dataUrl: "bafinal/list",
            url: "maindata",
            uploadPath: "/Helper/UploadData/Company",
            canCreate: false,
            canEdit: false,
            canDelete: false,
            canView: false,
            canPrint: false,
            expandedRows: [],
            pageSize : 10
        }
    },
    methods: {
        downloadPrint(type){
                this.$emit('block-ui');
                var self = this;
                // prefer the DataTable's current state (if available) to avoid stale params
                const dt = this.$refs.dt;
                const dtFilters = dt && dt.filters ? dt.filters : this.filters;
                const dtSorts = dt && dt.multiSortMeta ? dt.multiSortMeta : this.sorts;

                const filtersArr = [];
                if (dtFilters) {
                    for (const [key, value] of Object.entries(dtFilters)) {
                        filtersArr.push({ field: key ? key : null, value: value.value, matchMode: value.matchMode });
                    }
                }

                const sortsArr = [];
                if (dtSorts) {
                    for (var i = 0; i < dtSorts.length; i++) {
                        sortsArr.push({ field: dtSorts[i].field, order: dtSorts[i].order == 1 ? "ASC" : "DESC" });
                    }
                }

                self.lazyParams = {
                    start: this.start,
                    pageSize: this.pageSize,
                    sorts: sortsArr,
                    filters: filtersArr,
                    from_date: this.From_Date,
                    to_date: this.to_date,
                    type: type
                };


                this.$axios.post(this.$API_URL + "BaFinal/" + "downloadprint",self.lazyParams,{
                    responseType: 'blob',
                    timeout: this.$AXIOS_TIMEOUT_LONG
                })
                .then((response) => {
                    
                    if(type == "PDF"){
                        const blob = new Blob([response.data], { type: 'application/pdf' });
                        const url = URL.createObjectURL(blob);
                        window.open(url, '_blank');
                    }
                    else{
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        let fileName = response.headers["content-disposition"].split("filename=")[1].split(";")[0];
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', fileName);
                        document.body.appendChild(link);
                        link.click();
                    }   
                    self.$emit('unblock-ui');
                })
                .catch(function (err) {
                    self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: "File not found" + err, life: 120000});
                    self.blocked = false;
                    self.$emit('unblock-ui');
                });
        },
        rowClass(data) {
            return [
                    
                    //{ 'bg-red': data.Is_Deleted == 'Y' },
                ];
        },
        generatePdf(id){
            this.$router.push({ path: "/Print/ShowPrintBaFinal", query: {id: id } });
        },  
        onAuth(event) {
            this.canCreate = event.canCreate;
            this.canEdit = event.canEdit;
            this.canDelete = event.canDelete;
            this.canView = event.canView;
            this.canPrint = event.canPrint;
        },
        onPage(event) {
            this.start = event.first;
            this.pageSize = event.rows;
            this.loadLazyData();
        },
        onSort(event) {
            this.sorts = event.multiSortMeta;
            this.loadLazyData();
        },
        onFilter() {
            this.loadLazyData();
        },
        onSelect(event) {
            this.selectedRow = event.data;
        },
        onRowExpand(event) {
            this.expandedRows = [];
            this.expandedRows.push(event.data);
        },
        editor(mode, mainid,id) {
            this.$router.push({ path: "/BaFinal/Editor", query: { mode: mode, mainid : mainid,id: id } });
        },
        editorChild(mode, mainid,id) {
            this.$router.push({ path: "/BaFinal/EditorChild", query: { mode: mode, parentid : mainid,id: id } });
        },
        filter(mode) {
            this.$router.push({ path: this.filterPath, query: { mode: mode } });
        },
        sidebarMessage(event) {
            this.$toast.add(event);
        },
        loadLazyData() {
            this.loading = true;
            this.selectedRow = null;

            this.lazyParams = {
                start: this.start,
                pageSize : this.pageSize,
                sorts: this.dataSort,
                filters: this.dataFilter
            };

            var self = this;

            this.$axios.post(this.$API_URL + this.dataUrl, this.lazyParams)
                .then((response) => {
                    if (response.data.success) {
                        this.dataModel = response.data.data;
                        this.totalRecords = response.data.totalRecords;
                    }
                    else {
                        self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: this.$DEFAULT_TIMER });
                    }

                    this.loading = false;
                })
                .catch(function (err) {
                    self.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: this.$DEFAULT_TIMER });
                    self.loading = false;
                });
        },
        setFilters() {
            this.filters = {};
            var exportable = this.$refs.dt.columns.filter(c => c.props.field);
            for (var i = 0; i < exportable.length; i++) {
                var filterValue = null;
                if (this.stateFilters) {
                    var field = this.stateFilters[exportable[i].props.field];
                    if (field) filterValue = field.value;
                }
                this.filters[exportable[i].props.field] = { value: filterValue, matchMode: "contains" };
            }
        },
        onStateRestore(event) {
            this.start = event.first;
            this.pageSize = event.rows;
            this.stateFilters = event.filters;
            this.sorts = event.multiSortMeta;
        },
        onModalClose() {
            this.loadLazyData();
        },
        clearFilter() {
            this.filters = {};
            var exportable = this.$refs.dt.columns.filter(c => c.props.field);
            for (var i = 0; i < exportable.length; i++) {
                var fieldName = exportable[i].props.field;
                var filterValue = "";
                if (fieldName.includes("Date")) {
                    filterValue = null;
                }
                this.filters[exportable[i].props.field] = { value: filterValue, matchMode: "contains" };
            }
            this.loadLazyData();
        },
        importFile() {
            this.$router.push({ path: this.uploadPath });
        },
    },
    mounted() {
        this.$emit('unblock-ui');
        this.setFilters();
        this.loadLazyData();
        this.$showToast();
    },
    computed: {
        dataFilter() {
            var h = [];
            if (this.filters) {
                for (const [key, value] of Object.entries(this.filters)) {
                    h.push({
                        field: key ? key : null,
                        value: value.value,
                        matchMode: value.matchMode
                    });
                }
            }
            return h;
        },
        dataSort() {
            var h = [];
            if (this.sorts) {
                for (var x = 0; x < this.sorts.length; x++) {
                    h.push({
                        field: this.sorts[x].field,
                        order: this.sorts[x].order == 1 ? "ASC" : "DESC"
                    });
                }
            }
            return h;
        },
        filterBadge() {
            var badgeNumber = 0;

            this.dataFilter.filter(function (item) {
                if (item.value && item.field != "Status") {
                    badgeNumber++;
                }
            });

            return badgeNumber;
        }
    },
}
</script>
<style>
    #main .bg-red{
        background-color:rgb(233, 103, 103);
    }
</style>
<style #scoped>
.p-card .p-card-content {
    margin: 0 !important;
    padding: 0 !important;
}
</style>